import { useQuery } from "@tanstack/react-query";
import importFileService from "../api/importFileService";

export const useImportBatch = (batchId) => {
  const { getImportBatch } = importFileService();

  return useQuery({
    queryKey: ["get-import-batch", batchId],
    queryFn: async () => {
      const res = await getImportBatch(batchId);
      return res.data;
    },
    enabled: !!batchId,
  });
};
